<div class="viewer-container">

  <div *ngIf="isPdf" class="pdf-wrapper">
    <ngx-extended-pdf-viewer 
      [base64Src]="base64Data"
      [useBrowserLocale]="true" 
      [height]="'800px'">
    </ngx-extended-pdf-viewer>
  </div>

  <div *ngIf="isImage" class="image-wrapper">
    <img #imageElement [src]="imageSrc" alt="File Preview" style="max-width: 100%; display: none;" />
    </div>

</div>